import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import React, { PropsWithChildren } from "react";
import SimpleTooltip from "../../../Data/SimpleTooltip";
import { Info } from "@mui/icons-material";

interface Props {
    className?: string;
    large?: boolean;
    hint?: string;
}

const useStyles = makeStyles(() => ({
    root: {
        fontSize: "14px",
        fontWeight: "bold",
        margin: "0.75rem 0",
        display: "flex"
    },
    icon: {
        color: "rgba(0, 0, 0, 0.54)",
        marginLeft: "0.25rem",
        fontSize: "1.25rem"
    },
    iconLarge: {
        fontSize: "1.35rem"
    },
    large: {
        fontSize: "16px",
        margin: "1.25rem 0 1rem 0"
    }
}));

const SettingsLabel: React.FC<PropsWithChildren<Props>> = props => {
    const classes = useStyles();

    return (
        <span className={clsx(classes.root, props.large && classes.large, props.className)}>
            {props.children}
            {props.hint && (
                <SimpleTooltip
                    placement="right"
                    title={props.hint}>
                    <Info className={clsx(classes.icon, props.large && classes.iconLarge)} />
                </SimpleTooltip>
            )}
        </span>
    );
};

export default SettingsLabel;
